module.exports = __webpack_public_path__ + "media/images/riders/MICHAEL_JONES-d4ec4db1b0a9fbb9a5890060bb81e93f.png";